module.exports = __webpack_public_path__ + "static/media/fiftyappearances.2046a84e.jpg";